import { render } from "./QrFlbDetail.vue?vue&type=template&id=d8a37124&scoped=true"
import script from "./QrFlbDetail.vue?vue&type=script&lang=js"
export * from "./QrFlbDetail.vue?vue&type=script&lang=js"

import "./QrFlbDetail.vue?vue&type=style&index=0&id=d8a37124&lang=scss&scoped=true"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8a37124"]])

export default __exports__